var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_vm._t("default")],2),_c('v-col',{class:{ 'py-0': !_vm.hasError },attrs:{"cols":"12"}},[_c('dv-input',_vm._g(_vm._b({attrs:{"hide-details":"auto","value":_vm.value},on:{"update:error":function($event){_vm.hasError = $event}}},'dv-input',_vm.$attrs,false),_vm.$listeners))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }